exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#updateVistaCustomerModal .modal-header[data-v-bf56342e],\n#updateVistaCustomerModal .modal-footer[data-v-bf56342e] {\n  background: transparent;\n  border-bottom: 0;\n  border-top: 0;\n}\n.custom-tooltip[data-v-bf56342e] {\n  pointer-events: all !important;\n}\n.vista-button-disabled[data-v-bf56342e] {\n  cursor: not-allowed !important;\n}\n", ""]);

// exports
